import PropTypes from 'prop-types';

import { IconButton, Typography } from '@mui/material';
import { MIcon } from '../../@material-extend';

const ClockingsToolbarInit = (props) => {
  const { pagename, handleClickBack } = props;

  return (
    <>
      {handleClickBack && (
        <IconButton color="inherit" onClick={handleClickBack}>
          <MIcon icon="arrow_back_ios_new" />
        </IconButton>
      )}

      <Typography variant="h4" sx={stylePagename}>
        {pagename}
      </Typography>
    </>
  );
};
ClockingsToolbarInit.propTypes = {
  pagename: PropTypes.string.isRequired,
  handleClickBack: PropTypes.func
};

const stylePagename = {
  flexGrow: 1,
  maxWidth: 'initial !important', // override native value
  color: 'inherit'
};

export default ClockingsToolbarInit;
